module.exports = __webpack_public_path__ + "mo/img/puzzle_02.4d937f1c.svg";